// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"25340cc01ea98e40","4044":"731ebe71b6533783","4515":"25340cc01ea98e40","4969":"2387d8c68d511a97","5264":"b93b490d51e8863a","8378":"f1f8d779d800436a"}[chunkId] + ".css";
};